module.exports = __webpack_public_path__ + "static/img/about-img2.01f857a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/about-img2.png
// module id = +GEd
// module chunks = 0